<template>
  <v-app>
    <user-card class="auth-card">
      <template v-slot:header>
        <v-card-subtitle class="auth-card-header mb-2 dark-text">Авторизация</v-card-subtitle>
        <div v-if="error" class="error-text mt-3">
          <i class="ti-info"></i>
          {{ textError }}
        </div>
      </template>
      <template v-slot:body>
        <v-form ref="form" class="mt-4" v-model="valid" lazy-validation>

          <input
            type="text"
            class="field"
            v-model="login"
            v-on:keydown.enter="validate"
            placeholder="Логин"
          >
          <div class="password">
            <input
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              class="field"
              v-model="password"
              v-on:keydown.enter="validate"
              placeholder="Пароль"

            >
            <a href="#" class="password-control" @click="show = !show">
              <v-icon v-if="!show">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </a>
          </div>

          <v-btn
            v-if="!preloader"
            :disabled="!valid"
            type="submit"
            style="height: 42px;"
            color="pink"
            class="success-btn primary-btn"
            @click="validate"
          >
            Войти
          </v-btn>
          <v-btn
            v-else
            style="height: 42px;"
            color="pink"
            class="success-btn primary-btn"
          >
            <v-progress-circular indeterminate></v-progress-circular>
          </v-btn>

          <span @click="reset" class="second-border-btn">Очистить форму</span>

          <div class="oauth-divider"><span>или</span></div>

          <v-btn
            style="height: 42px;"
            outlined
            color="pink"
            class="success-btn bitrix-btn"
            @click="loginWithBitrix"
          >
            Войти через Битрикс24
          </v-btn>
        </v-form>
      </template>
    </user-card>
  </v-app>
</template>

<script>
import UserCard from "@/pages/UserProfileTeamplate/UserCard";
export default {
  name: "AuthenticationPage",
  components: {
    UserCard
  },

  props: {},
  data() {
    return {
      preloader: false,
      valid: true,
      login: "",
      password: "",
      show: false,
      error: false,
      textError: "",
    };
  },

  mounted() {
    if (this.$route.query.authError) {
      this.error = true;
      this.textError = this.$route.query.authError;
    }

    const token = this.getCookie('token');
    const currentUser = localStorage.getItem('current_user');

    if (token && currentUser) {
      const redirect = localStorage.getItem('after_login_redirect');
      localStorage.removeItem('after_login_redirect');

      if (redirect && redirect !== '/authentication') {
        this.$router.replace(redirect);
        return;
      }

      this.$router.replace('/profile');
    }
  },

  methods: {
    submit() {},
    async validate() {
      this.preloader = true

      let options = {
        login: this.login,
        password: this.password
      }

      let dataAuth = await this.request("/login", "POST", options);
      console.log(dataAuth)

      if(dataAuth) {
        if (dataAuth.success) {
          let userId = dataAuth.data.user.id
          let role = dataAuth.data.user.roles

          let new_minut = new Date();
          new_minut.setMinutes(new_minut.getMinutes() + 30);

          document.cookie = `token=${dataAuth.data.token};expires=${new_minut.toUTCString()};`;
          document.cookie = `refresh_token=${dataAuth.data.refreshToken};expires=${new_minut.toUTCString()};`;

          localStorage.setItem('current_user', JSON.stringify(userId));
          localStorage.setItem('role', JSON.stringify(role));

          if(dataAuth.data.user.subordinates.length > 0)
            localStorage.setItem('head', true);
          else
            localStorage.setItem('head', false);


          const redirect = localStorage.getItem('after_login_redirect');
          localStorage.removeItem('after_login_redirect');

          if (redirect && redirect !== '/authentication') {
            this.$router.replace(redirect);
            return;
          }

          this.$router.replace('/profile');

        }
        else {
          this.error = true;
          this.textError =
            this.login === '' || this.password === ''
              ? "Заполните все поля"
              : "Неверный логин или пароль";
        }

        this.preloader = false;
      }
      else {
        this.preloader = false
        this.textError = "Ошибка при авторизации"
      }
    },
    reset() {
      this.login = ''
      this.password = ''
      this.$refs.form.reset();
    },
    loginWithBitrix() {
      window.location.href = process.env.VUE_APP_BACKEND_URL + "/auth/bitrix/login";
    },
    async request(method, type, body) {
      let fetchBody = {
        method: type,
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
        redirect: 'follow'
      }
      let query = fetch(process.env.VUE_APP_BACKEND_URL + method, fetchBody)

      return query
        .then(async (response) => {
          if (!response.ok) {
            return Promise.reject({ // реджект обламывает текущий промис и передает ошибку в catch
              message: 'На запрос ' + method + ' получена ошибка со статусом ' + response.status + '. ' + response.statusText,
              statusCode: response.status,
              serviceAnswer: await response.json()
            });
          }
          return Promise.resolve(response.json())
              .then((data) => {
                return data
              })
        }).catch(error => {
          console.log("Ошибка же ну")
          console.log(error)
          return error
        })
    },

    getCookie(name) {
      const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([$?*|{}\]\\^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    },

  },
};
</script>

<style scoped>
.auth-card {
  margin-top: 150px;
  padding: 50px;
  min-width: 380px;
}
.auth-card-header {
  padding: 0;
  margin-bottom: 20px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
}
.success-btn {
  width: 100%;
  margin-bottom: 20px;
  text-transform: unset;
  font-weight: 400;
}
.oauth-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13px;
  margin: 10px 0 16px;
}
.oauth-divider::before,
.oauth-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
}
.oauth-divider span {
  padding: 0 10px;
}
.bitrix-btn {
  width: 100%;
}



</style>
